import styled, { css } from 'styled-components';

const decorativeStyle = css`
  height: 42px;
  font-weight: 500;
  font-size: 18px;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    margin-bottom: 6px;
  }
`;

export const StyledButton = styled.button`
  padding: 6px 10px;
  background: var(--secondary-color);
  border: none;
  text-align: left;
  display: inline-flex;
  flex-direction: column;
  min-width: 45px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  user-select: none;

  &[data-mode='danger'] {
    min-width: 120px;
    background: rgb(232, 89, 21);
    ${decorativeStyle}
  }

  &[data-mode='warning'] {
    min-width: 120px;
    background: rgb(40, 234, 27);
    color: rgb(33, 34, 43);

    & > span {
      color: rgb(33, 34, 43);
    }
    ${decorativeStyle}
  }

  &:disabled {
    cursor: default;
    background: #777;
  }

  &[data-mode='count-down'] {
    min-width: 120px;
    flex-direction: row;
    background: rgba(255, 227, 16, 0.2);
    color: rgba(255, 227, 16, 1);
    & > span {
      margin-right: 6px;
      min-width: 53px;
      text-align: right;
    }

    & > svg {
      max-width: 20px;
      min-height: 20px;
    }
    ${decorativeStyle}
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    border-radius: 4px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0);
    transition: all 0.2s;
    z-index: 1;
  }

  @media (min-width: 990px) and (min-aspect-ratio: 1/1) {
    &:not(:disabled):hover:before {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`;

export const StyledLabel = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: var(--manatee-color);
  text-transform: uppercase;
  margin-bottom: 4px;
  position: relative;
  z-index: 2;

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    margin-bottom: 0;
  }
`;

export const StyledText = styled.span`
  display: block;
  font-size: 17px;
  font-weight: 500;
  color: var(--inverse-color);
  text-transform: uppercase;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  text-align: center;
  z-index: 2;

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    span {
      font-size: 14px;
    }
  }
`;
